<template>
  <!-- ============ ENGLISH ============ -->
  <div class="pt-5" v-if="currentLanguage == 'en'" style="background-color: #F6F9FB;">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>Color Picker From Image</h1>
        <p>Identify and copy color codes instantly from your images.</p>
      </div>
      
      <div class="tool">
        <colorpicker-com></colorpicker-com>
      </div>


    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">Image Color Picker Guide and FAQs</h2>
        <p class="help-subtitle">Learn how to use the SplendApp Color Picker</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="Help topics">
        <button type="button" role="tab" id="color-picker-en-faq-tab" aria-controls="color-picker-en-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          Frequently Asked Questions
        </button>
        <button type="button" role="tab" id="color-picker-en-guide-tab" aria-controls="color-picker-en-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          Usage Guide
        </button>
      </nav>

      <!-- FAQ Pane EN -->
      <div v-show="activeTab === 'faq'" id="color-picker-en-faq-panel" role="tabpanel" aria-labelledby="color-picker-en-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> Technical Questions
        </div>
        <div v-for="(item, i) in enFaqTechnical" :key="'t'+i" class="faq-item" :class="{ open: openFaq === 'en-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-t-'+i ? null : 'en-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> Usage & Features
        </div>
        <div v-for="(item, i) in enFaqUsage" :key="'u'+i" class="faq-item" :class="{ open: openFaq === 'en-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-u-'+i ? null : 'en-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> Privacy & Rights
        </div>
        <div v-for="(item, i) in enFaqRights" :key="'r'+i" class="faq-item" :class="{ open: openFaq === 'en-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-r-'+i ? null : 'en-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane EN -->
      <div v-show="activeTab === 'guide'" id="color-picker-en-guide-panel" role="tabpanel" aria-labelledby="color-picker-en-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="Search the usage guide...">
          <span class="search-icon">🔍</span>
        </div>
        <div id="guideContent">
          <div v-for="(step, i) in filteredStepsEn" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsEn.length === 0" class="no-results">Sorry, no results found.</p>
      </div>
    </section>

  </div>


  <!-- ============ ARABIC ============ -->
  <div class="pt-5" style="direction: rtl; background-color: #F6F9FB;" v-else-if="currentLanguage == 'ar'">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>استخراج الألوان من الصور</h1>
        <p>تعرف على الألوان وانسخ الأكواد من صورك فورًا بسهولة وبدقة عالية.</p>
      </div>
      
      <div class="tool">
        <colorpicker-com></colorpicker-com>
      </div>


    </section>


    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">دليل استخراج الألوان والأسئلة الشائعة</h2>
        <p class="help-subtitle">تعرف على أداة استخراج الألوان من سبلينداب</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="موضوعات المساعدة">
        <button type="button" role="tab" id="color-picker-ar-faq-tab" aria-controls="color-picker-ar-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          الأسئلة الشائعة
        </button>
        <button type="button" role="tab" id="color-picker-ar-guide-tab" aria-controls="color-picker-ar-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          دليل الاستخدام
        </button>
      </nav>

      <!-- FAQ Pane AR -->
      <div v-show="activeTab === 'faq'" id="color-picker-ar-faq-panel" role="tabpanel" aria-labelledby="color-picker-ar-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> أسئلة تقنية
        </div>
        <div v-for="(item, i) in arFaqTechnical" :key="'art'+i" class="faq-item" :class="{ open: openFaq === 'ar-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-t-'+i ? null : 'ar-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> الاستخدام والميزات
        </div>
        <div v-for="(item, i) in arFaqUsage" :key="'aru'+i" class="faq-item" :class="{ open: openFaq === 'ar-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-u-'+i ? null : 'ar-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> الخصوصية والحقوق
        </div>
        <div v-for="(item, i) in arFaqRights" :key="'arr'+i" class="faq-item" :class="{ open: openFaq === 'ar-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-r-'+i ? null : 'ar-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane AR -->
      <div v-show="activeTab === 'guide'" id="color-picker-ar-guide-panel" role="tabpanel" aria-labelledby="color-picker-ar-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="ابحث في دليل الاستخدام...">
          <span class="search-icon">🔍</span>
        </div>
        <div>
          <div v-for="(step, i) in filteredStepsAr" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsAr.length === 0" class="no-results">عذراً، لم نجد نتائج تطابق بحثك.</p>
      </div>
    </section>

  </div>
</template>

<script>
import ColorpickerCom from '@/components/ColorCom.vue'
import ToolsComen from '@/components/ToolsComen.vue';
import ToolsComar from '@/components/ToolsComar.vue';

export default {
  name: 'ColorPickerPage',
  components: { ColorpickerCom, ToolsComen, ToolsComar },
  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      title: '',
      description: '',
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // ─── English FAQ Data ──────────────────────────────────────
      enFaqTechnical: [
        {
          q: 'What image formats does the color picker support?',
          a: 'The tool supports all standard web image formats including JPG, PNG, WebP, and GIF.'
        },
        {
          q: 'How accurate is the color picking?',
          a: 'It is 100% pixel-perfect. We extract the exact RGB and HEX values directly from the image data rendered in your browser.'
        },
        {
          q: 'Will it work with high-resolution (4K) images?',
          a: "Yes! Our tool uses dynamic rendering to extract pixels, so it won't freeze your browser even with massive, high-resolution photographs."
        }
      ],
      enFaqUsage: [
        {
          q: 'How do I pick a specific pixel color?',
          a: 'Simply click or drag your mouse over the uploaded image. The magnifier will update to show you the 10x10 area around your cursor, allowing for pinpoint selection.'
        },
        {
          q: 'What color codes are provided?',
          a: 'Currently, the tool provides industry-standard HEX codes (e.g., #FFFFFF) and RGB codes (e.g., rgb(255,255,255)) ready to copy.'
        }
      ],
      enFaqRights: [
        {
          q: 'Do you upload or save my images?',
          a: 'No. Your privacy is paramount. All image rendering and color extraction happens locally on your device. We do not upload your pictures to any server.'
        }
      ],

      // ─── English Guide Steps ───────────────────────────────────
      enGuideSteps: [
        {
          title: 'Upload Your Image',
          desc: 'Drag and drop an image into the box, or click to upload a file from your computer.',
          placeholder: '[Tip: Use images with good lighting to get the most accurate color codes]',
          keywords: 'upload images select files'
        },
        {
          title: 'Select an Area',
          desc: 'Click anywhere on the uploaded image. The magnifier on the right will zoom in on that exact spot, showing individual pixels.',
          placeholder: '[Tip: You can drag your mouse across the image to explore colors live]',
          keywords: 'pick select color magnifier zoom'
        },
        {
          title: 'Refine Selection',
          desc: 'If you want a very specific pixel, click directly on the small square inside the 10x10 magnifier grid.',
          placeholder: '[Tip: The center pixel of the grid is selected by default]',
          keywords: 'pixel grid exact precise'
        },
        {
          title: 'Copy Codes',
          desc: 'Scroll down to see the selected color. Click the copy icon next to the HEX or RGB code to copy it directly to your clipboard.',
          placeholder: '[Tip: HEX codes are ideal for Web Design (CSS)]',
          keywords: 'copy clipboard hex rgb code'
        }
      ],

      // ─── Arabic FAQ Data ───────────────────────────────────────
      arFaqTechnical: [
        {
          q: 'ما هي صيغ الصور المدعومة في هذه الأداة؟',
          a: 'تدعم الأداة جميع صيغ الصور القياسية للويب، بما في ذلك JPG، PNG، WebP، و GIF.'
        },
        {
          q: 'ما مدى دقة الألوان المستخرجة؟',
          a: 'دقيقة بنسبة 100%. نحن نستخرج قيم الـ RGB والـ HEX الفعلية من بيانات الصورة التي يتم عرضها في متصفحك.'
        },
        {
          q: 'هل تعمل الأداة مع الصور عالية الدقة (مثل 4K)؟',
          a: 'نعم! تستخدم أداتنا نظام معالجة ديناميكي للبيكسلات، لذا لن تتسبب في تجميد متصفحك حتى مع الصور الفوتوغرافية الضخمة.'
        }
      ],
      arFaqUsage: [
        {
          q: 'كيف أختار لون بيكسل محدد جداً؟',
          a: 'ببساطة اضغط أو اسحب الفأرة على الصورة. سيتم تحديث المكبر ليظهر لك مساحة 10x10 بيكسل حول المؤشر لتتمكن من الاختيار بدقة متناهية.'
        },
        {
          q: 'ما هي أكواد الألوان التي توفرها الأداة؟',
          a: 'حالياً توفر الأداة الأكواد القياسية للتصميم وهي HEX (مثل #FFFFFF) و RGB (مثل rgb(255,255,255)) جاهزة للنسخ.'
        }
      ],
      arFaqRights: [
        {
          q: 'هل يتم رفع أو حفظ صوري على خوادمكم؟',
          a: 'لا. خصوصيتك هي الأهم. تتم جميع عمليات استخراج الألوان محلياً على جهازك، ولا يتم رفع أي صورة إلى أي خادم (Server).'
        }
      ],

      // ─── Arabic Guide Steps ────────────────────────────────────
      arGuideSteps: [
        {
          title: 'رفع الصورة',
          desc: 'اسحب وأفلت صورة داخل المربع، أو اضغط لرفع ملف من جهازك.',
          placeholder: '[تلميح: استخدم صوراً ذات إضاءة جيدة للحصول على أكواد ألوان دقيقة]',
          keywords: 'رفع الصور اختيار ملفات'
        },
        {
          title: 'تحديد المنطقة',
          desc: 'اضغط على أي مكان في الصورة المرفوعة. سيقوم المكبر الموجود بتكبير تلك النقطة، مما يظهر لك البيكسلات الفردية.',
          placeholder: '[تلميح: يمكنك سحب الفأرة عبر الصورة لاستكشاف الألوان مباشرة]',
          keywords: 'مكبر تحديد لون بيكسل'
        },
        {
          title: 'اختيار دقيق',
          desc: 'إذا كنت تريد لون بيكسل محدد جداً، اضغط مباشرة على المربع الصغير داخل شبكة المكبر 10x10.',
          placeholder: '[تلميح: يتم اختيار البيكسل الأوسط في الشبكة بشكل افتراضي]',
          keywords: 'دقة تحديد بيكسل مربع'
        },
        {
          title: 'نسخ الأكواد',
          desc: 'انزل للأسفل لرؤية اللون المحدد. اضغط على أيقونة النسخ بجوار كود HEX أو RGB لنسخه مباشرة.',
          placeholder: '[تلميح: أكواد HEX مثالية لتصميم الويب (CSS)]',
          keywords: 'نسخ كود لون hex rgb'
        }
      ]
    }
  },

  computed: {
    filteredStepsAr() {
      if (!this.guideSearch) return this.arGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.arGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    },
    filteredStepsEn() {
      if (!this.guideSearch) return this.enGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.enGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    }
  },

  watch: {
    '$store.state.currentLanguage': function (newLanguage) {
      this.currentLanguage = newLanguage;
      this.openFaq = null;
      this.guideSearch = '';
      
      if (this.currentLanguage == 'en') {
        this.$router.push({ name: 'color-picker-en' }).catch(()=>{});
      } else {
        this.$router.push({ name: 'color-picker-ar' }).catch(()=>{});
      }
    }
  }
}
</script>

<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

.ad-banner {
  max-width: 100%;
  border-radius: 12px;
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

[dir="rtl"] .search-box {
  input {
    padding: 15px 20px 15px 45px;
  }
  .search-icon {
    right: auto;
    left: 15px;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

[dir="rtl"] .step-card {
  border-right: none;
  border-left: 5px solid #3a7afe;
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
  display: none;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 769px) {
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
